import messages from '../locales/hu_HU.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'hu-HU',
};
export default lang;
